import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { HeaderReactComponent } from '../header-react/header-react.component';
import { MenuReactComponent } from '../menu-react/menu-react.component';
import { ReactMainComponent } from '../react-main/react-main.component';
import { FooterReactComponent } from '../footer-react/footer-react.component';
import { loadRemote } from '@module-federation/enhanced/runtime';

@Component({
  selector: 'prf-layout',
  standalone: true,
  imports: [RouterOutlet, NgIf, HeaderReactComponent, MenuReactComponent, ReactMainComponent, FooterReactComponent],
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit {
  @Input() public showMenu = true;
  @Input() public showHeader = true;
  @Input() public showFooter = true;
  @ViewChild('b2gNewTools', { read: ViewContainerRef }) b2gNewToolsViewContainer!: ViewContainerRef;

  public ngOnInit(): void {
    this.loadRemotes().then();
  }

  public async loadRemotes() {
    try {
      const b2gnew = await loadRemote('pflm_b2gnew/AppRemoteComponent');

      // @ts-ignore
      this.b2gNewToolsViewContainer.createComponent(b2gnew.default);
    } catch (e) {
      console.error(e);
    }
  }
}
